<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
const props = defineProps({ snapshot: { type: Object, default: null }, stale: { type: Boolean, default: false }, compact: { type: Boolean, default: false } });
const roles = { creator: 'Владелец', administrator: 'Администратор', member: 'Участник', restricted: 'Ограничен', left: 'Не в группе', kicked: 'Удалён из группы' };
const labels = {
  can_manage_chat: 'Управление группой', can_change_info: 'Изменение описания',
  can_delete_messages: 'Удаление сообщений', can_restrict_members: 'Блокировка участников',
  can_invite_users: 'Пригласительные ссылки', can_pin_messages: 'Закрепление сообщений',
  can_manage_topics: 'Управление темами', can_manage_video_chats: 'Управление видеочатами',
  can_post_stories: 'Публикация историй', can_edit_stories: 'Редактирование историй',
  can_delete_stories: 'Удаление историй', can_promote_members: 'Назначение администраторов',
  can_manage_tags: 'Управление тегами', can_send_welcome_messages: 'Приветственные сообщения',
  is_anonymous: 'Анонимность',
};
const rights = computed(() => (props.snapshot?.rights || []).filter(key => labels[key]));
const checked = computed(() => props.snapshot?.checked_at ? new Date(props.snapshot.checked_at).toLocaleString('ru-RU') : null);
</script>

<template>
  <section aria-label="Бот в группе" class="rounded-xl border border-n-weak bg-n-alpha-1 p-4">
    <div v-if="snapshot" class="flex flex-col gap-4" :class="compact ? '' : 'md:flex-row md:gap-6'">
      <div class="flex items-start gap-3" :class="compact ? '' : 'md:w-64 md:shrink-0'">
        <div class="flex size-9 shrink-0 items-center justify-center rounded-lg bg-n-alpha-2 text-n-slate-11">
          <Icon icon="i-lucide-bot" class="size-5" aria-hidden="true" />
        </div>
        <div class="min-w-0">
          <p class="m-0 text-xs text-n-slate-11">Бот в группе</p>
          <p class="my-1 break-words text-sm font-medium text-n-slate-12">{{ snapshot.name || 'Бот' }}</p>
          <p v-if="snapshot.username" class="m-0 break-all text-xs text-n-slate-11">@{{ snapshot.username }}</p>
          <span class="mt-2 inline-flex rounded-md bg-n-alpha-2 px-2 py-1 text-xs font-medium text-n-slate-11">{{ roles[snapshot.role] || 'Роль неизвестна' }}</span>
        </div>
      </div>
      <div class="min-w-0 flex-1">
        <p class="mb-2 mt-0 text-xs font-medium text-n-slate-11">Права в Telegram</p>
        <ul v-if="rights.length" class="m-0 flex list-none flex-wrap gap-1.5 p-0" aria-label="Выданные права бота">
          <li v-for="key in rights" :key="key" class="rounded-md bg-n-alpha-2 px-2 py-1 text-xs leading-5 text-n-slate-12">{{ labels[key] }}</li>
        </ul>
        <p v-else class="m-0 text-sm text-n-slate-11">{{ ['left', 'kicked'].includes(snapshot.role) ? 'Бот больше не состоит в группе.' : 'Административные права не выданы.' }}</p>
        <p class="mb-0 mt-3 text-xs text-n-slate-10">{{ stale ? 'Показаны последние полученные данные. ' : '' }}{{ checked ? 'Проверено: ' + checked + '. ' : '' }}Изменение прав — в Telegram.</p>
      </div>
    </div>
    <p v-else class="m-0 flex items-center gap-2 text-sm text-n-slate-11">
      <Icon icon="i-lucide-bot" class="size-4 shrink-0" aria-hidden="true" />
      Данные бота ещё не получены. Они появятся после фоновой проверки.
    </p>
  </section>
</template>
